import React from "react";
import { Link } from "react-router-dom";

function WhoWeAre() {
  return (
    <div className="who-we-are-bg py-5 ">
      <div className="p-5 who-we-are-main">
        {/* <div className="row w-100 fs-1 fw-bold who-we-are-heading">
          <div className="col-md-6 text-end" style={{ color: "#9367B1" }}>
            Beyond Boundaries:
          </div>{" "}
          <div className="col-md-6 ">Who We Are</div>
        </div> */}
        <div className="fs-1 fw-bold who-we-are-heading w-100 text-center">
            <span style={{ color: "#9367B1" }}>Beyond Boundaries:</span>
            <span> Who We Are</span>
        </div>
        <div className="d-flex justify-content-center px-5 fs-4 mt-4 who-we-are-content">
          <div className="w-75 m-auto d-flex text-center who-we-are-para-content">
            Vizzhy is revolutionizing healthcare by integrating advanced
            multi-omics technologies, IoT-enabled health monitoring and
            Generative AI to decode an individual’s metabolic signature. As the
            world’s first platform to focus on metabolic health through these
            innovations, we are setting a new standard in healthcare by
            addressing the root causes of metabolic disorders. Our approach is
            powered by a combination of in-depth knowledge, cutting-edge
            science, and state-of-the-art technologies, including computational
            biology, advanced computing systems, IoT devices, and machine
            learning techniques.
          </div>
        </div>
        <Link to="/our-approach" className="forgot-link">
        <div className="d-flex mt-4 justify-content-center p-3">
          <div className="d-flex justify-content-center align-items-center  primary-btn fw-bold  py-3 px-5 learn-more contact-us">
            <div>Learn More</div>
            <span class="material-symbols-outlined ms-1">arrow_right_alt</span>
          </div>
        </div></Link>
        
      </div>
    </div>
  );
}

export default WhoWeAre;
